import type { Dinero } from 'dinero.js';
import { dinero, toDecimal, toSnapshot } from 'dinero.js';
import { PLN as PLN_CURRENCY } from '@dinero.js/currencies';

export type { Dinero };

export const PLN = PLN_CURRENCY;

/** Tworzy Dinero PLN z groszy (np. 50000000 = 500 000,00 PLN) */
export function pln(amountInGrosze: number): Money {
  return new Money(dinero({ amount: amountInGrosze, currency: PLN }));
}

/** Konwertuje PLN z DB (np. 500000.50) na Money w groszach */
export function plnFromMajor(amountInPln: number): Money {
  return new Money(dinero({ amount: Math.round(amountInPln * 100), currency: PLN }));
}

const PLN_FORMATTER = new Intl.NumberFormat('pl-PL', {
  style: 'currency',
  currency: 'PLN',
  maximumFractionDigits: 0,
});

/**
 * Value object wrapping Dinero with convenient numeric conversion.
 */
export class Money {
  constructor(readonly dinero: Dinero<number>) {}

  /** Lossy conversion to plain number (PLN). */
  toNumber(): number {
    return Number(toDecimal(this.dinero));
  }

  /** Amount in grosze (smallest unit). */
  get grosze(): number {
    return toSnapshot(this.dinero).amount;
  }

  /** Format as "300 000 zł" (pl-PL currency, 0 fraction digits). */
  format(): string {
    return PLN_FORMATTER.format(this.toNumber());
  }
}

/** Standalone formatter for raw PLN amounts (e.g. from DB). Returns '-' for null; "Nie podano" gdy kwota niepoprawna (NaN/undefined z parseFloat pustej wartości). */
export function formatPLN(amount: number | null | undefined): string {
  if (amount === null) return '-';
  if (typeof amount !== 'number' || !Number.isFinite(amount)) return 'Nie podano';
  return PLN_FORMATTER.format(amount);
}
